import { useDispatch } from "react-redux";

import { RecipeUploaderActions } from "@hmn/coolinarika-web-core/actions";
import { DRAWER_ACTIONS, useDrawerDispatch } from "@hmn/coolinarika-web-core/context/Drawer";

import { Button, buttonSizes, ButtonsRow, buttonVariants } from "../../../Button";
import { DrawerBody, DrawerFooter, DrawerImageBlock, DrawerTextBlock } from "../../../Drawer";
import { withErrorBoundary } from "../../../ErrorBoundary";

const DrawerSuccess = () => {
    const dispatch = useDispatch();
    const drawerDispatch = useDrawerDispatch();

    const handleEditClick = () => {
        // TODO: do something on edit

        drawerDispatch({
            type: DRAWER_ACTIONS.CLOSE_DRAWER,
            payload: {
                drawerType: null,
            },
        });
    };

    const handleViewClick = () => {
        // TODO: go to recipe page when id is generated?

        dispatch(RecipeUploaderActions.close());
        dispatch({
            type: DRAWER_ACTIONS.CLOSE_DRAWER,
            payload: {
                drawerType: null,
            },
        });
    };

    return (
        <>
            <DrawerBody>
                <DrawerTextBlock
                    title="Recept je uspješno snimljen!"
                    // eslint-disable-next-line
                    description="Uspješno si doradio svoj recept, što će zasigurno pomoći ostalim Coolinarika korisnicima u kuhanju. :)"
                    bottomSpacing={40}
                />
                <DrawerImageBlock
                    image="/images/recipe-uploader/success.png"
                    imageWidth={379}
                    imageHeight={398}
                />
            </DrawerBody>
            <DrawerFooter>
                <ButtonsRow>
                    <Button
                        onClick={handleEditClick}
                        title="Uređivanje"
                        variant={buttonVariants.SECONDARY}
                        size={buttonSizes.LARGE}
                        sizeMobile={buttonSizes.NORMAL}
                    >
                        Uređivanje
                    </Button>
                    <Button
                        onClick={handleViewClick}
                        title="Pogledaj recept"
                        variant={buttonVariants.QUATERNARY}
                        size={buttonSizes.LARGE}
                        sizeMobile={buttonSizes.NORMAL}
                    >
                        Pogledaj recept
                    </Button>
                </ButtonsRow>
            </DrawerFooter>
        </>
    );
};

export default withErrorBoundary(DrawerSuccess);
